import { color } from "chart.js/helpers";
import React, { useState, useEffect } from "react";
import { tripUnavailableDateService } from "../../../services/tripUnavailableDateService";
import { toast } from "../../../services/toastService";
import { useParams } from "react-router-dom";
import Loading from "../../../components/common/Loading";

const UnavailableBookingDayCalendar = ({ t,tripId }) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    getAsync();
  }, []);

  const getAsync=async()=>{
    try {
      setLoading(true);
      const response=await tripUnavailableDateService.getAsync(tripId);
      if (!response.isSuccess) {
        toast.error(t("anErrorOccurredPleaseTryAgainLater"));
        console.log(response);
        return;
      }
      setData(response.value);
    } catch (error) {
      console.log(error)
    }
    finally{
      setLoading(false);
    }
  }

  const addAsync=async(date)=>{
    try {
      setLoading(true);
      const response=await tripUnavailableDateService.createAsync(tripId,date);
      if (!response.isSuccess) {
        toast.error(t("anErrorOccurredPleaseTryAgainLater"));
        console.log(response);
        return;
      }
      toast.success(t("recordAddedSuccessfully"));
      getAsync();
    } catch (error) {
      console.log(error)
    }
    finally{
      setLoading(false);
    }

  }

  const today = new Date();
  const currentYear = today.getFullYear();
  const currentMonth = today.getMonth(); // 0 = Jan

  const [selectedMonth, setSelectedMonth] = useState(currentMonth);

  // Generate month options from current month to December
  const months = Array.from(
    { length: 12 - currentMonth },
    (_, i) => currentMonth + i,
  );

  // Generate dates for the selected month
  const generateDates = (month) => {
    const year = currentYear;
    const lastDate = new Date(year, month + 1, 0).getDate();
    const dates = [];
    for (let d = 1; d <= lastDate; d++) {
      const date = new Date(year, month, d);
      const day = date.toLocaleDateString("en-US", { weekday: "short" });
      const isPast = date < today.setHours(0, 0, 0, 0); // disable past dates
      dates.push({ day, date: d, disabled: isPast });
    }
    return dates;
  };

  const dates = generateDates(selectedMonth);

  const handlePrev = () => {
    if (selectedMonth > currentMonth) setSelectedMonth(selectedMonth - 1);
  };

  const handleNext = () => {
    if (selectedMonth < 11) setSelectedMonth(selectedMonth + 1);
  };
  const handleDateClick = async (d, isoDate,isDisabled) => {
  const apiItem = data.find((x) => x.date === isoDate);
  const status = apiItem?.status?.toLowerCase();

  if (status === "booked") return;
  
  

  if (status === "unavailable") {
    console.log(apiItem);
    await handleDelete(apiItem?.id);
    return;
  }
  if(isDisabled)return;
  await addAsync(isoDate);
};
  const handleDelete =async (id)=>{
    try {
      setLoading(true);
      var response = await tripUnavailableDateService.deleteAsync(id);
      if (!response.isSuccess) {
        toast.error(t(response.key));
        console.log(response);
        return;
      }
      toast.success(t("recordDeletedSuccessfully"));
      getAsync();
    } catch (error) {
      console.log(error)
    }
    finally{
      setLoading(false);
    }
  }
if(loading) return <Loading/>
  return (
    <section className="closed-booking-calendar">
      <div className="calendar-header">
        <i
          className={`fas fa-arrow-circle-left calendar-month ${selectedMonth === currentMonth ? "disabled-month" : ""}`}
          onClick={handlePrev}
        ></i>
        <span>
          {new Date(currentYear, selectedMonth).toLocaleString("default", {
            month: "long",
          })}{" "}
          {currentYear}
        </span>
        <i
          className={`fas fa-arrow-circle-right calendar-month ${selectedMonth === 11 ? "disabled-month" : ""}`}
          onClick={handleNext}
        ></i>
      </div>
      <span className="calendar-available-time">
        <i className="fas fa-info-circle"></i>
        {t("availableFromNightAndDayFrom1030am")}
      </span>
      <div className="calendar-dates">
        {dates.map((d, idx) => {
          const fullDate = new Date(currentYear, selectedMonth, d.date);

          const isoDate = fullDate.toISODateString();

          const apiItem = data.find((x) => x.date === isoDate);

          const status = apiItem?.status?.toLowerCase();

          const isDisabled =
            d.disabled || status === "booked" || status === "unavailable";

          return (
            <div
              key={idx}
              onClick={() => handleDateClick(d, isoDate,isDisabled)}
              className={`calendar-date-day 
              ${d.disabled ? "disabled-date" : ""} 
              ${status === "booked" ? "booked-date disabled-date" : ""} 
              ${status === "unavailable" ? "locked-date" : ""} 
              ${isDisabled ? "not-allowed" : ""}`}
                  >
                    <span className="calendar-date">{d.date}</span>
                    <span className="calendar-day">{d.day}</span>
                  </div>
                );
        })}
      </div>
      <div className="calendar-footer">
        <div>
          <i className="fas fa-users"></i> {t("green")} = {t("booked")}
        </div>
        <div>
          <i className="fas fa-users"></i> {t("red")} = {t("locked")}
        </div>
      </div>
    </section>
  );
};

export default UnavailableBookingDayCalendar;
